module.exports = __webpack_public_path__ + "img/vuejs.394545fb.svg";